module.exports = __webpack_public_path__ + "static/media/shape_I.8cff477e.glb";